import { DotsThreeOutlineVertical } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';
import type { ToggleProps } from 'src/v2/commonComponents/DrawerTooltipContainer';

export const MoreMessageActionsToggle = ({
  id,
  isActive,
  disabled,
  onClick,
}: ToggleProps) => {
  return (
    <div id={id}>
      <Button
        color={isActive ? 'tertiary' : 'secondary-outline'}
        onClick={onClick}
        disabled={disabled}
      >
        <DotsThreeOutlineVertical size={SVG_SIZE_M} />
      </Button>
    </div>
  );
};
